<template>
  <div>
    <highcharts :options="chartOptions"/>
  </div>
</template>

<script>

import {Chart} from 'highcharts-vue'

export default {
  props: ['chartData'],
  components: {
    highcharts: Chart
  },
  created() {
    this.updateChart();
  },
  watch: {
    'chartData': {
      handler: function (val, oldVal) {
        this.updateChart();
      },
      deep: true,
    }
  },
  data() {
    return {
      colors: [],
      chartOptions: {
        chart: {
          height: 300,
          // type: 'spline'
        },
        title: {
          text: 'Все заявки'
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },
        series: [{
          name: 'Всего',
          data: [],
          color: '#6cb5f9'
        }],
        tooltip: {
          shared: true,
          crosshairs: true
        },
        yAxis: {
          title: {
            text: 'Заявки'
          },
        },
        xAxis: {
          categories: [],
          labels: {
            // enabled: false
            padding: 2,
            step: 1,
            formatter: function () {
              const label = this.axis.defaultLabelFormatter.call(this);
              console.log(label);
              return label;
            }
          }
        }
      }
    }
  },
  methods: {
    updateChart() {
      this.chartOptions.xAxis.categories = (this.chartData ?? []).map((d) => d.start);
      this.chartOptions.series = [{
        name: 'Поступило',
        data: (this.chartData ?? []).map((d) => {
          return d?.report?.totalOrders ?? 0
        }),
        color: '#6cb5f9'
      },
        {
          name: 'Оплачены',
          data: (this.chartData ?? []).map((d) => {
            return d?.report?.closedOrder?.total ?? 0
          }),
          color: '#4fc47f'
        }
      ];
    }
  }
}

</script>
